import { lazy } from "react";

export const PageViewNotificationDetail = lazy(() => import("./Detail"));
